"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var IntercomWidget_1 = require("./IntercomWidget");

var Intercom = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Intercom, _React$PureComponent);

  function Intercom(props) {
    var _this;

    _classCallCheck(this, Intercom);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Intercom).call(this, props));
    _this.widget = IntercomWidget_1.IntercomWidget.getInstance();

    if (!_this.widget.appId) {
      _this.widget.init(props.appId, props.settings);
    } else {
      if (_this.widget.appId !== props.appId) {
        throw new Error("Intercom widget already inicialized with app id \"".concat(props.appId, "\". Only one intercom widget is allowed."));
      } // Else, all settings will be ignored but no notice will be given

    }

    return _this;
  }

  _createClass(Intercom, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderWidget();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.widget.settings = this.props.settings;
      this.renderWidget();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.widget.unmount();
    }
  }, {
    key: "renderWidget",
    value: function renderWidget() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = this.props.data;
                _context.prev = 1;
                _context.next = 4;
                return this.widget.inject();

              case 4:
                this.widget.render(data);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);
                console.error('Could not render intercom', _context.t0.message);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7]]);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Intercom;
}(React.PureComponent);

exports.default = Intercom;
Intercom.defaultProps = {
  data: {},
  settings: {
    alignment: 'left',
    horizontal_padding: 10,
    vertical_padding: 10
  }
};